import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Reveal from '@/components/feature/Reveal';
import { SITE } from '@/config/site';

export default function Privacidad() {
  return (
    <div className="min-h-screen bg-background-950">
      <Navbar />
      <main className="pt-32 md:pt-40 pb-20">
        <div className="mx-auto max-w-3xl px-4 md:px-6">
          <Reveal>
            <h1 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950">
              Política de Privacidad
            </h1>
            <p className="mt-4 text-sm text-foreground-500">
              Última actualización: 2026.
            </p>
            <div className="mt-8 space-y-6 text-foreground-500 leading-relaxed">
              <p>
                En ACOMA nos comprometemos a proteger la privacidad de los datos
                que recibimos a través de este sitio. Esta política describe cómo
                tratamos la información que nos proporcionas al completar
                formularios de contacto.
              </p>
              <div>
                <h2 className="text-lg font-semibold font-heading text-foreground-950">
                  Información que recopilamos
                </h2>
                <p className="mt-2">
                  Recopilamos únicamente la información que nos envías
                  voluntariamente a través del formulario de contacto: nombre,
                  empresa, email, teléfono y los detalles de tu proyecto.
                </p>
              </div>
              <div>
                <h2 className="text-lg font-semibold font-heading text-foreground-950">
                  Uso de la información
                </h2>
                <p className="mt-2">
                  Utilizamos esta información exclusivamente para responder a tus
                  consultas y dar seguimiento a proyectos solicitados. No
                  compartimos tus datos con terceros sin tu consentimiento.
                </p>
              </div>
              <div>
                <h2 className="text-lg font-semibold font-heading text-foreground-950">
                  Contacto
                </h2>
                <p className="mt-2">
                  Si tienes preguntas sobre esta política, puedes escribirnos a{' '}
                  <a
                    href={`mailto:${SITE.email}`}
                    className="text-primary-300 hover:text-primary-200"
                  >
                    {SITE.email}
                  </a>
                  .
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </main>
      <Footer />
    </div>
  );
}